import { Cluster } from "../models/Cluster";
import { Company } from "../models/Company";
import { ApprovalLevel } from "../models/Master/ApprovalLevel";
import { RoleName } from "../models/Master/RoleName";
import { OnBoardingReason } from "../models/OnboardingReason";
import { ProcurementCategory } from "../models/ProcurementCategory";
import { RMCategory } from "../models/RMCategory";
//import { Role } from "../models/Role";
import { SBU } from "../models/SBU";
import { UserRole } from "../models/UserRole";
import { AxiosConfig } from "./AxiosConfig";

const getUserRoles = async (
  successCallback: (userRolesist: Array<UserRole>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`AppRole/GetAppRole`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getClusters = async (
  successCallback: (clustersList: Array<Cluster>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`GrpCluster/GetGrpClusters`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getRoleNames = async (
  successCallback: (roleNameList: Array<RoleName>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`Vendor/GetRoleNameList`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getApprovalLevels = async (
  successCallback: (approvalLevelList: Array<ApprovalLevel>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`VendorMasterData/GetApprovalPoints`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getRMCategories = async (
  successCallback: (rmCategoryList: Array<RMCategory>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`RMCategory/GetRMCategories`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getProcurementCategories = async (
  successCallback: (rmCategoryList: Array<ProcurementCategory>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`ProcurementCategory/GetProcurementCategories`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getOnBoardingReasons = async (
  vendorcategoryId: number,
  successCallback: (onboardingreasonList: Array<OnBoardingReason>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`VendorOnboardingReason/GetVendorOnboardingReason`,{
      params: { vendorcategoryId: vendorcategoryId, }
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};
export const MasterMetaDataService = {
  getUserRoles,
  getRoleNames,
  getApprovalLevels,
  getClusters,
  getRMCategories,
  getOnBoardingReasons,
  getProcurementCategories
};
